<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div
            class="col d-flex align-items-center"
            style="padding: 0%;"
        >
          <b-link
              :to="{ name: 'adminTreinamentos' }"
              class="font-weight-bold d-block text-nowrap mr-3 mb-2"
          >
            <el-button
                style="border: none; background-color: transparent;"
                type="button"
                class="is-plain"
            >
              <i class="el-icon-back"/>
              Criar conteúdo
            </el-button>
          </b-link>
        </div>
        <b-card-code
            title="Título"
            :style="{width: '582.2px', boxSizing: 'border-box' }"
        >
          <div class="col">
            <b-form-input
                v-model="valueTitulo"
                type="text"
                debounce="500"
            />
          </div>
          <div class="divider"/>
          <div class="row">
            <div class="col">
              <div class="divider"/>
              <div class="col-md-4">
                <b-form-group class="mb-0">
                  <b-form-input
                      v-model="selectedOption"
                      list="my-list-id"
                      placeholder="Pesquisar Video"
                      @input="onSearch(selectedOption)"
                  />
                  <datalist id="my-list-id">
                    <option
                        v-for="size in options"
                        :key="size.id"
                        :label="size.vsl_name"
                        :value="size.vsl_name"
                    />
                  </datalist>
                </b-form-group>
              </div>
              <b-card-code
                  title="Video"
                  :style="{ minWidth: 'calc(582.2px / 3)', boxSizing: 'border-box' }"
              >
                <div>
                  <b-embed
                      type="iframe"
                      aspect="16by9"
                      :src="selectedValue"
                      allowfullscreen
                  />
                </div>
              </b-card-code>
            </div>
          </div>
        </b-card-code>
      </div>
      <div class="col">
        <div class="col d-flex justify-content-end align-items-center">
          <div class="mr-3 mb-2">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="CreateConteudo()"
            >
              Salvar Produto
            </b-button>
          </div>
        </div>
        <b-card
            :style="{ width: '582.2px', height: '500px' }"
        >
          <b-card-code
              title="Editor de conteúdo"
              :style="{ boxSizing: 'border-box', height: '100%' }"
          >
            <quill-editor
                v-model="content"
                :options="snowOption"
                :style="{ height: '70%' }"
            />
          </b-card-code>
        </b-card>
        <b-card class="custom-card align-items-center justify-content-center">
          <b-card-code title="Você pode anexar arquivos">
            <el-upload
                class="upload-demo"
                drag
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                multiple
                :file-list="list"
                :before-upload="handleChange"
            >
              <i class="el-icon-upload"/>
              <div class="el-upload__text">
                Drop file here or <em>selecione do computador</em>
              </div>
              <div
                  slot="tip"
                  class="el-upload__tip"
              />
            </el-upload>
          </b-card-code>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import {
  BFormInput, BCardText, BFormTextarea, BEmbed, BFormGroup,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {quillEditor} from 'vue-quill-editor'
import Conteudo from '@/services/Conteudo'

// eslint-disable-next-line import/no-cycle
import router from '@/router'
import {useApi} from '@/composables/useApi'
import {UploadFilesService} from '@/services/UploadFiles'

import axios from 'axios'

const uploadFilesService = new UploadFilesService()
const api = useApi()

const conteudo = new Conteudo()
export default {
  name: 'CriarConteudo',
  components: {
    quillEditor,
    BCardCode,
    BFormInput,
    BCardText,
    BFormTextarea,
    BEmbed,
    BFormGroup,

  },
  data() {
    return {
      list: [],
      selectedOption: '',
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      searchQuery: '',
      selectedValue: '',
      options: [],
      valueTextearea: '',
      valueTitulo: '',
      snowOption: {
        theme: 'snow',
      },
      content: '',
      value: '',
      params: {
        id_conteudo: '',
        file_name: '',
        file_bucket_address: '',
        file_key_name: '',
        file_type: '',
        id_user: '',
        file_uid: '',
        selectedObjectId: '',
      },
    }
  },

  computed: {
    selectedUrl() {
      // find the object that matches the selected option
      const option = this.options.find(option => option.vsl_name === this.selectedOption)
      // return its url or an empty string if not found
      return option ? option.vsl_bucket_address : ''
    },

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    getUidConteudo() {
      return localStorage.getItem('uidConteudo')
    },
  },
  mounted() {
    this.getvsls()
  },
  methods: {
    async CreateConteudo() {
      const params = {
        conteudo_titulo: this.valueTitulo,
        modulo_id: router.currentRoute.params.id,
        conteudo_content: this.content,
        conteudo_files: '',
        conteudo_video_url: this.selectedValue,
        conteudo_sequencia: 1,
        uid: this.getUidConteudo,
        id_vsl: this.selectedObjectId,
      }

      await conteudo.createConteudo(params).then(() => {
        this.$notify({
          title: 'Sucesso',
          message: 'Conteúdo criado com sucesso',
          type: 'success',
        })
        localStorage.removeItem('uidConteudo')
        router.push({name: 'adminTreinamentos'})
      })
    },

    onSearch(searchQuery) {
      const selectedObject = this.options.find(
          option => option.vsl_name === searchQuery,
      )

      if (selectedObject) {
        this.selectedObjectId = selectedObject.id
      }

      this.searchQuery = searchQuery
      this.selectedValue = this.selectedUrl
      this.getvsls()
    },
    async getvsls() {
      await api.get(`/getVslUserById?id_user=${this.getUserData.id}&vsl_name=${this.searchQuery}`)
          .then(response => {
            this.options = response.data
          })
    },

    handlePreview(file) {
      console.log('Arquivo pré-visualizado:', file)
    },
    async handleRemove(file) {
      console.log('Arquivo removido:', file)
      await uploadFilesService.delefile(file.uuid)
      const index = this.list.findIndex(item => item.uuid === file.uuid)
      if (index !== -1) {
        this.list.splice(index, 1)
        console.log(`O item com uuid ${file.uuid} foi removido da lista.`)
      } else {
        console.log(`O item com uuid ${file.uuid} não existe na lista.`)
      }
    },
    handleChange(file) {
      this.handleUpload(file, file.uid)
    },
    async handleUpload(file, uid) {
      const formData = new FormData()
      const caminho = `${this.getUserData.user_file_key}Upload_Files/`
      formData.append('file', file)
      formData.append('caminho', caminho)
      await axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/UploadArquivos`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(response => {
        this.params = {
          id_conteudo: this.getUidConteudo,
          file_name: response.data.data.fileNameOrigin,
          file_bucket_address: response.data.data.fileUrl,
          file_key_name: response.data.data.key_filename,
          file_type: response.data.data.file_type,
          id_user: this.getUserData.id,
          file_uid: uid,
        }
        const obj = {
          name: response.data.data.fileNameOrigin,
          url: response.data.data.fileUrl,
          uuid: uid,
        }

        this.list.push(obj)
      })
      await uploadFilesService.uploadfile(this.params).then(() => {
      })
    },
  },

}
</script>

<style scoped>
.custom-card {
  width: 582.2px;
  height: 399px;
}
</style>
